import {RootState} from "../store";

function selectUnreadAnnouncementsNumber(state: RootState): number {
	return state.announcements.numberOfUnread;
}

export default selectUnreadAnnouncementsNumber;
